import React from 'react';
import { Box } from '@mui/system';
import { FormImage, ImageWrapper, PKDContainer } from './styles';

export const FormWrapper = ({ children, image }) => {
  return (
    <PKDContainer
      marginTop='60px'>
      <ImageWrapper
        data-testid='image-wrapper'>
        <FormImage
          src={image} alt={image}
        />
      </ImageWrapper>
      <Box
        data-testid='box'>{children}</Box>
    </PKDContainer>
  );
};
